export default __webpack_public_path__ + "static/media/CertificationRedevances.4ca577f0.PNG";